export const REVIEW_PERIOD_START_ATTR_ID =
  '72b3b1e5-5be3-4d3d-bd5e-518e36c93122';
export const REVIEW_PERIOD_END_ATTR_ID = 'e7df5213-e9d0-476a-8515-cedd2e095c7b';

export const REVIEW_TAG = 'Цели';
